"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CheckListWithImage;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/styles");
const SplitWithImage_1 = require("../SplitWithImage/SplitWithImage");
const CheckedItem_1 = __importDefault(require("./CheckedItem"));
const variables_1 = __importDefault(require("../../styles/variables"));
const useStyles = (0, styles_1.makeStyles)({
    checkItem: { marginBottom: variables_1.default.spacing(5) },
});
function CheckListWithImage({ items, imageAltText, imageUrl, }) {
    const classes = useStyles();
    return (react_1.default.createElement(SplitWithImage_1.SplitWithImage, { leftGridSize: 5, rightGridSize: 4, spacing: 3, imageAltText: imageAltText, imageUrl: imageUrl, mdDownHide: true },
        react_1.default.createElement("div", null, items.map(({ header, details }) => (react_1.default.createElement(CheckedItem_1.default, { key: header, header: header, details: details, className: classes.checkItem }))))));
}
